







































































































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Notify, Dialog, Toast } from 'vant';
import moment from 'moment';
import * as api from '@/api';
import { PcList } from '@/data/pcitys';
import axios from 'axios';
import UserModule from '@/store/modules/user';
enum TrainingClassLevel {
  中组部调训班次 = 1,
  自治区党委组织部调训班次 = 2,
  其他班次 = 3,
}
@Component({ [Notify.Component.name]: Notify.Component })
export default class DeclarationForm extends Vue {
  isLoading: boolean = false;
  isShowLoseProve = false;
  stuImgs: any = [];
  loseImgs: any = [];
  losePreviewImg = '';
  isDisabled: boolean = false;
  showTrainTypePicker: boolean = false;
  previewImg: any = '';
  loading: boolean = false;
  finished: boolean = false;
  showStartTimePicker: boolean = false;
  showEndTimePicker: boolean = false;
  showAddressPicker: boolean = false;
  showRootLevelPicker: boolean = false;
  showChildLevelPicker: boolean = false;
  showOrgPicker: boolean = false;
  showCitysPicker: boolean = false;
  showPcPicker: boolean = false;
  citys: any = [
    '南宁市',
    '柳州市',
    '桂林市',
    '梧州市',
    '北海市',
    '防城港市',
    '钦州市',
    '贵港市',
    '玉林市',
    '百色市',
    '贺州市',
    '河池市',
    '来宾市',
    '崇左市',
  ];
  PcList: any = [];
  classList: any = [];
  rootLevelData: any = [];
  childLevelData: any = [];
  organizations: any = [];
  trainTypeList: any = [];
  showClassPopup: boolean = false;
  searchClassName: string = '';
  //省市区地址
  areaAddress: string = '';
  studentInfo: Partial<any> = {
    name: '',
    workUnit: '',
    job: '',
    phone: '',
    deptId: '',
  };
  form: any = {
    // name: '',
    // phone: '',
    // deptId: '',
    // job: '',
    // workUnit: '',
    className: '',
    //默认为其他班次
    classType: 2,
    publicTrainingClassId: '',
    //详细地址
    address: '',
    province: '',
    city: '',
    district: '',
    detailedAddress: '',
    startDate: '',
    endDate: '',
    days: 0,
    trainingRootLevelstr: '',
    trainingChildLevelstr: '',
    trainingLevel: '',
    organization: '',
    sponsor: '',
    //培训地点类别，区内、区外
    locationCategory: '',
    //结业证书图片key
    certificate: '',
    //培训内容类型
    trainType: '',
    LostProof: '',
  };
  isThroughState: string = ''; // 审核状态判断
  trainingId: string = ''; // 培训记录id

  async mounted() {
    this.PcList = PcList;
    this.isLoading = true;
    await this.getLevelData();
    // await this.getPersonInfo();
    await this.gettrainTypeList();
    if (this.$route.query.detailData) {
      this.form = JSON.parse(this.$route.query.detailData as any);
      this.form.startDate = moment(this.form.startDate).format('YYYY-MM-DD');
      this.form.endDate = moment(this.form.endDate).format('YYYY-MM-DD');
      this.trainingId = this.$route.query.id as string;
      this.form.trainingRootLevelstr = this.rootLevelData.find(e => e.key == this.form.trainingRootLevelstr).value;
      this.form.trainType = this.form.trainType === '专业化能力' ? '履职能力' : this.form.trainType;
      this.isThroughState = this.$route.query.isThroughState as string;
      if (this.form.certificate) {
        this.getStuImg('结业证书', this.form.certificate);
      }
      this.isDisabled = true;
    }
    this.isLoading = false;
  }

  async onDel() {
    Dialog.confirm({
      message: '确定删除吗？',
    }).then(async () => {
      try {
        const { data } = await api.TrainRecords.deletes_POST({
          ids: [this.trainingId],
        });
        Notify({ type: 'success', message: '删除成功' });
        this.$router.go(-1);
      } catch (error) {
        Notify({ type: 'danger', message: error });
      }
    });
  }

  editData() {
    this.isDisabled = false;
  }

  onClassSearch(value: string) {
    this.seachClasses(value, this.studentInfo.name);
  }
  async gettrainTypeList() {
    try {
      await apiAxios
        .get('/api/Standard/GetItemFromCode?code=TrainingType', axiosOptions)
        .then(res => {
          if (res.data.data) {
            let trainTypeData = res.data.data.sort((a: any, b: any) => a.order - b.order);
            trainTypeData.forEach((trainType: any) => {
              this.trainTypeList.push(trainType.name);
            });
          }
        })
        .catch(err => {});
    } catch (err) {
      console.log('%c [ err ]-373', 'font-size:13px; background:pink; color:#bf2c9f;', err);
    }
  }
  async getPersonInfo() {
    const { data } = await api.AccountApp.getUserPersonalInfo_GET();
    this.studentInfo = data!;
    this.form.name = this.studentInfo.name;
    this.form.phone = this.studentInfo.phone;
    this.form.deptId = this.studentInfo.deptId;
    this.form.job = this.studentInfo.job;
    this.form.workUnit = this.studentInfo.workUnit;
  }
  async getLevelData() {
    const { data } = await api.TrainRecords.getTrainingLevelData_GET();
    if (data) {
      let originalData = JSON.parse(data);
      let parentData: any = [];
      originalData.forEach((item: any) => {
        let object = { code: '', value: '', organizations: [], child: [] };
        object.code = item.code;
        object.value = item.value;
        object.organizations = item.organizations;
        object.child = item.children;
        parentData.push(object);
      });
      this.rootLevelData = parentData;
    }
  }
  onRightSearch(value: string) {
    this.seachClasses(value, this.studentInfo.name);
  }

  chooseClassList(classItem: any) {
    this.showClassPopup = false;
    if (this.classList.length > 0) {
      this.form.className = classItem.className;
      this.form.startDate = moment(classItem.startDate).format('YYYY-MM-DD');
      this.form.endDate = moment(classItem.endDate).format('YYYY-MM-DD');
      this.form.classType = classItem.classType;
      this.form.publicTrainingClassId = classItem.id;
      //自动计算培训天数
      this.autoComputeDays(this.form.startDate, this.form.endDate);
    } else {
      this.form.startDate = '';
      this.form.endDate = '';
      this.form.days = 0;
      this.form.className = classItem;
      this.form.classType = 2;
    }
  }

  //查询可填写培训记录的培训班
  async seachClasses(className: string, studentName: string) {
    this.loading = true;
    try {
      this.classList = [];
      const { data } = await api.TrainRecords.findClassByName_GET({
        className: className,
        studentName: studentName,
      });
      this.classList = data;
    } finally {
      this.loading = false;
    }
  }
  onClickLeft() {
    this.$router.go(-1);
  }
  onStartTimeConfirm(value: any) {
    this.form.startDate = moment(value).format('YYYY-MM-DD');
    this.showStartTimePicker = false;
    this.autoComputeDays(this.form.startDate, this.form.endDate);
  }
  onEndTimeConfirm(value: any) {
    this.form.endDate = moment(value).format('YYYY-MM-DD');
    this.showEndTimePicker = false;
    this.autoComputeDays(this.form.startDate, this.form.endDate);
  }
  //自动计算天数
  autoComputeDays(startDate: any, endDate: any) {
    //判断开始时间是否大于结束时间
    if (new Date(startDate) >= new Date(endDate)) {
      this.form.startDate = '';
      this.form.endDate = '';
      this.form.days = 0;
      Notify({
        message: '开始日期不能大于或等于截止日期',
        type: 'warning',
        duration: 5000,
      });
    }

    if (startDate && endDate && new Date(endDate) > new Date(startDate)) {
      let day1: any = new Date(startDate);
      let day2: any = new Date(endDate);
      let result = day2 - day1;
      this.form.days = Math.abs(result) / 1000 / 60 / 60 / 24 + 1;
    }
  }
  onRootLevelConfirm(trainingLevel: any, index: Array<number>) {
    this.form.trainingLevel = trainingLevel.value;
    this.form.trainingChildLevelstr = '';
    this.form.organization = '';
    this.form.trainingRootLevelstr = trainingLevel.value;
    this.organizations = trainingLevel.organizations;
    if (trainingLevel.child) {
      this.childLevelData = [];
      trainingLevel.child.forEach((item: any) => {
        let object = { code: '', value: '', organizations: [], child: [] };
        object.code = item.code;
        object.value = item.value;
        object.organizations = item.organizations;
        object.child = item.children;
        this.childLevelData.push(object);
      });
    }
    this.showRootLevelPicker = false;
  }
  onChildLevelConfirm(trainingLevel: any, index: Array<number>) {
    console.log('trainingLevel', trainingLevel);
    this.form.organization = '';
    this.form.trainingLevel = trainingLevel.value;
    this.form.trainingChildLevelstr = trainingLevel.value;
    if (trainingLevel.organizations) {
      this.organizations = trainingLevel.organizations;
    } else {
      this.organizations = [];
    }

    this.showChildLevelPicker = false;
  }
  onOrgConfirm(organization) {
    this.form.organization = organization.value;
    this.showOrgPicker = false;
  }
  onTrainTypeConfirm(trainType: string) {
    this.form.trainType = trainType;
    this.showTrainTypePicker = false;
  }
  onCitysConfirm(city: string) {
    this.form.address = city;
    this.showCitysPicker = false;
  }
  onPcitysConfirm(pcity: any) {
    if (pcity) {
      if (pcity[0].name != pcity[1].name) {
        this.form.address = pcity[0].name + pcity[1].name;
        this.form.province = pcity[0].name;
        this.form.city = pcity[1].name;
      } else {
        this.form.address = pcity[0].name;
        this.form.province = pcity[0].name;
        this.form.city = pcity[0].name;
      }
    }
    this.showPcPicker = false;
  }
  async onSubmit() {
    try {
      let _this = this;
      //培训班类型为其他，判断结业证书是否上传
      if (_this.form.classType == 2) {
        if (!this.form.certificate) {
          Dialog.alert({
            message: '请先上传结业证书',
          });
          return false;
        }
      }

      const { data, success, message } = await api.TrainRecords.mobileSave_POST({
        Type: 0,
        className: _this.form.className,
        startDate: _this.form.startDate,
        endDate: _this.form.endDate,
        days: _this.form.days,
        trainingLevel: TrainingClassLevel[_this.form.trainingLevel],
        organization: _this.form.organization,
        locationCategory: _this.form.locationCategory,
        address: _this.form.address,
        classType: _this.form.classType,
        certificate: _this.form.certificate,
        trainType: _this.form.trainType === '履职能力' ? '专业化能力' : _this.form.trainType,
        sponsor: _this.form.sponsor,
        province: _this.form.province,
        city: _this.form.city,
      });
      if (success) {
        //申报成功，清空form
        for (let k of Object.keys(this.form)) {
          Vue.delete(this.form, k);
        }
        Dialog.alert({
          message: '添加成功，请耐心等待审核',
        }).then(() => {
          this.$router.go(-1);
        });
      } else {
        Dialog.alert({
          message: '添加失败',
        });
      }
    } finally {
      this.loading = false;
      this.finished = true;
    }
  }
  beforeUpload(file: any) {
    if (file.type !== 'image/jpeg') {
      Dialog.alert({
        message: '请上传 jpg 格式图片',
      });
      return false;
    }
    return true;
  }

  genGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      let r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  loseClick() {
    this.isShowLoseProve = true;
  }

  beforeRead(file: any) {
    const imgformat = /image\/(png|jpg|jpeg)$/;
    if (!imgformat.test(file.type)) {
      Toast.fail('请上传 jpg/jpeg/png 格式图片');
      return false;
    }
    return true;
  }

  async afterUpload(file: any) {
    let _this = this;
    _this.stuImgs = [];
    _this.previewImg = file.content;
    _this.form.certificate = _this.genGuid();
    await _this.uploadFile(file, _this.form.certificate, '结业证书');
  }

  async loseAfterUpload(file: any) {
    this.loseImgs = [];
    this.losePreviewImg = file.content;
    this.form.LostProof = this.genGuid();
    await this.uploadFile(file, this.form.certificate, '结业证书遗失证明');
  }

  async getStuImg(keyName: string, key: string) {
    const { data } = await apiAxios.get('/api/NewAttachment/GetAttachmens', {
      params: {
        StringKey1: key,
        Category: keyName,
      },
    });
    this.stuImgs = data;
  }

  async uploadFile(file: any, key: string, fileName) {
    let formData = new FormData();
    formData.append('file', file.file);
    formData.append('StringKey1', key);
    formData.append('Category', fileName);
    try {
      await apiAxios
        .post('/api/NewAttachment/Upload', formData, axiosOptions)
        .then(res => {})
        .catch(err => {});
    } catch (err) {
      Dialog.alert({
        message: '上传失败',
      });
    }
  }
}
const axiosOptions: AxiosRequestConfig = {
  baseURL: process.env.VUE_APP_ROOT,
  headers: {
    Authorization: `${'Bearer ' + UserModule.getToken}`,
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
};
const apiAxios = axios.create(axiosOptions);

export interface AxiosRequestConfig {
  baseURL?: string;
  headers: object;
}
